import { useState } from 'react';
import { EZ5050IndicatorsModal } from './EZ5050IndicatorsModal';
import { EZ5050OrderPanel } from './EZ5050OrderPanel';
import './trading.css';

/**
 * EZ5050TradingLayout
 * 
 * Replicates the exact trading reference UI.
 * Wraps around the existing UpDownTradingPanel which renders its own chart + order controls.
 */
export function EZ5050TradingLayout({
    children,           // The existing UpDownTradingPanel
    // Wallet
    wallet,
    luckyData,
    // Active orders for positions table
    activeOrders = [],
    historyOrders = [],
    // Pair info
    activePairLabel,
    payoutRate,
    isReady = true,
}) {
  const [indicatorsOpen, setIndicatorsOpen] = useState(false);
  const [indicatorConfig, setIndicatorConfig] = useState({
    ma1Active: true, ma1Period: 20, ma1Color: '#818cf8',
    ma2Active: true, ma2Period: 50, ma2Color: '#f59e0b',
    rsiActive: true, rsiPeriod: 14,
    macdActive: true, macdFast: 12, macdSlow: 26, macdSignal: 9,
  });

  const balance = wallet?.balance ?? 0;

  return (
    <>
      <div className={`flex-1 flex flex-col md:flex-row overflow-hidden ez5050-trading-panel-override ${isReady ? 'is-page-ready' : 'page-is-loading'}`} style={{ minWidth: 0, background: '#0b0e14' }}>
        
        {/* Left/Center Column: Toolbar + Chart + Positions */}
        <div className="flex-1 flex flex-col overflow-hidden ez-anim-chart" style={{ minWidth: 0 }}>
          
          <div className="flex-1 flex flex-row overflow-hidden" style={{ minHeight: 0 }}>

            {/* Main Content Area - Chart */}
            <div className="flex-1 relative min-w-0 min-h-0" style={{ background: '#0b0e14' }}>
              <div className="absolute inset-0 flex flex-col overflow-hidden">
                {children}
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Order Panel */}
        <div className="flex-none flex flex-col overflow-hidden w-full md:w-[320px] border-t md:border-t-0 md:border-l ez-anim-order" style={{ background: '#0b0e14', borderColor: 'rgba(252, 68, 32, 0.15)' }}>
          <EZ5050OrderPanel 
              balance={balance}
              timeSettings={wallet?.binary?.time_settings}
              amountSettings={wallet?.binary?.amount_settings}
              wallet={wallet}
              luckyData={luckyData}
            payoutRate={payoutRate || 0.82}
            onExecuteOrder={(dir, amount, durationSecs) => {
              window.dispatchEvent(new CustomEvent('set-ez5050-amount', { detail: { amount } }));
              window.dispatchEvent(new CustomEvent('set-ez5050-time', { detail: { seconds: durationSecs } }));

              // Delay slightly to let React state update (amount & duration), then trigger trade
              setTimeout(() => {
                const upBtn = document.querySelector('.ez5050-trading-panel-override .up-new-button');
                const downBtn = document.querySelector('.ez5050-trading-panel-override .down-new-button');
                
                if (dir === 'UP' && upBtn) upBtn.click();
                if (dir === 'DOWN' && downBtn) downBtn.click();
              }, 50);
            }}
          />
        </div>
      </div>

      {/* Indicators Modal */}
      {indicatorsOpen && (
        <EZ5050IndicatorsModal
          config={indicatorConfig}
          onUpdate={setIndicatorConfig}
          onClose={() => setIndicatorsOpen(false)}
        />
      )}
    </>
  );
}
